module.exports = __webpack_public_path__ + "static/media/9C.d262b698.svg";